import axios from 'axios';
import { Payment } from 'types';

export const fetchProductPayment = (brandId: number, productId: number) =>
  axios.get<Payment[]>(
    `/api/brands/${brandId}/products/${productId}/payment_methods`
  );
